module.exports = __webpack_public_path__ + "img/5.aba77b08.png";